export const formatUrlWithAffiliateCode = (url) => {
  const affiliateCode = `cid=aff_inf&sv1=affiliate&sv_campaign_id=946733&awc=30347_1664905670_43058d7a615f2c210ae5a45cf39f981d`;
  return `${url}&${affiliateCode}`;
};
